<template>
  <modal-frame :submit="submit"
               :shape-width="600" :shape-height="450"
               :disable-cancel-button="true"
               class="modal-frame">

    <div class="title-wrapper">

      <span class="title">
        회원가입 승인
      </span>

    </div>

    <div class="contents-wrapper">

      <div class="contents">
        <p class="contents-header">소속</p>
        <p class="contents-text">{{ param.division }}</p>
      </div>

      <div class="contents">
        <p class="contents-header">등급</p>
        <p class="contents-text">{{ param.grade }}</p>
      </div>

      <div class="contents">
        <p class="contents-header">이메일</p>
        <p class="contents-text">{{ param.email }}</p>
      </div>

      <div class="contents">
        <p class="contents-header">이름</p>
        <p class="contents-text">{{ param.name }}</p>
      </div>

      <div class="contents">
        <p class="contents-header">핸드폰 번호</p>
        <p class="contents-text">{{ param.phone }}</p>
      </div>

      <div class="contents">
        <p class="contents-header">매장명 (번호)</p>
        <p class="contents-text">{{ param.pickup_place_name }}</p>
      </div>

    </div>

  </modal-frame>
</template>

<script>
import ModalFrame from '../ModalFrame';

export default {
  name: 'ModalSignupConfirm',
  props: {
    param: Object,
  },
  components: {
    ModalFrame,
  },
  methods: {
    async submit() {
      const result = await this.$store.dispatch('confirmRequestSignupUser', { id: this.param.id });

      if (result.response) {
        this.$modal.clearComponent();
        this.$table.updateField();
      }

      this.$toast(result.message);
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-frame {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;

  .title-wrapper {
    display: flex;
    justify-content: flex-start;
    padding: 24px 32px;

    .title {
      color: rgb(55, 168, 175);
      font-size: 22px;
    }
  }

  .contents-wrapper {
    display: flex;
    padding: 0 32px;
    flex-wrap: wrap;
    justify-content: flex-start;
    flex-direction: column;

    .contents {
      display: flex;
      flex-direction: row;
      padding-left: 15px;
      width: 100%;

      .contents-header {
        flex: 1;
        font-size: 20px;
        text-align: left;

        border-right: 1px solid rgba(0, 0, 0, 0.2);
        margin-right: 20px;

        color: rgba(0, 0, 0, 0.5);
      }

      .contents-text {
        flex: 2;
        font-size: 20px;
        text-align: left;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/modal/board-modal/ModalSignupConfirm.vue